import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "animate.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/scale-extreme.css";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";

import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { HashRouter as Router } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./pages/Errors/ErrorFallback";
import { customToast } from "./utils/General";

const container = document.getElementById("root");
const root = createRoot(container);
const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime:0,
      staleTime: 0,
    },
  },
});
const persistor = persistStore(store);

if (process.env.NODE_ENV !== "development") console.log = () => {};

window.addEventListener("load", () => {
  function handleNetworkChange() {
    if (!navigator.onLine) {
      customToast('error','ارتباط شما با سرور / اینترنت قطع است!')
    } else {
    }
  }
  window.addEventListener("online", handleNetworkChange);
  window.addEventListener("offline", handleNetworkChange);
});

root.render(
  <QueryClientProvider client={client}>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <App />
          </Router>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </QueryClientProvider>
);
